/*
 * @Date: 2022-06-09 15:06:26
 * @LastEditors: puxue
 * @LastEditTime: 2024-03-21 10:35:30
 */
export default [
  {
    path: '/activity/quotes',
    name: 'language',
    component: () => import('@/pages/activity/quotes'),
    meta: { title: '房车语录征集', requireAuth: true },
  },
  {
    path: '/activity/vote',
    name: 'vote',
    component: () => import('@/pages/activity/vote'),
    meta: { title: '投票', requireAuth: true },
  },
  {
    path: '/activity/oldwithnew',
    name: 'oldwithnew',
    component: () => import('@/pages/activity/oldNew/index'),
    meta: { title: '邀请好友', requireAuth: true },
  },
  {
    path: '/activity/oldwithnew/reward',
    name: 'reward',
    component: () => import('@/pages/activity/oldNew/reward'),
    meta: { title: '奖励明细', requireAuth: true },
  },
  {
    path: '/activity/oldwithnew/share',
    name: 'oldwithnew-share',
    component: () => import('@/pages/activity/oldNew/share'),
    meta: { title: '分享海报', requireAuth: true },
  },
  {
    path: '/activity/oldwithnew/cash',
    name: 'oldwithnew-cash',
    component: () => import('@/pages/activity/oldNew/cash'),
    meta: { title: '提现', requireAuth: true },
  },
  {
    path: '/activity/worldCup',
    name: 'worldCup',
    component: () => import('@/pages/activity/worldCup'),
    meta: { title: '欧洲杯之夜', requireAuth: true },
  },
  {
    path: '/activity/film',
    name: 'film',
    component: () => import('@/pages/activity/film'),
    meta: { title: '', requireAuth: true },
  },
  {
    path: '/activity/xianXia',
    name: 'xianXia',
    component: () => import('@/pages/activity/xianXia'),
    meta: { title: '', requireAuth: true },
  },
  {
    path: '/activity/vote2',
    name: 'vote2',
    component: () => import('@/pages/activity/vote2'),
    meta: { title: '', requireAuth: true },
  },
  {
    path: '/activity/page',
    name: 'page',
    component: () => import('@/pages/activity/page/index'),
    meta: { title: '', requireAuth: true },
  },
  {
    path: '/activity/play24',
    name: 'play24',
    component: () => import('@/pages/activity/play24'),
    meta: { title: '', requireAuth: true },
  },
  {
    path: '/activity/miniLoading/:tag/:id?',
    name: 'miniLoading',
    component: () => import('@/pages/activity/miniLoading'),
    meta: { title: '正在打开小程序', requireAuth: true },
  },
  {
    path: '/activity/semActivity',
    name: 'semActivity',
    component: () => import('@/pages/activity/semActivity'),
    meta: { title: '房车生活家新人大礼包', requireAuth: true },
  },
  {
    path: '/activity/carResourceList',
    name: 'carResourceList',
    component: () => import('@/pages/activity/page/carResourceList'),
    meta: { title: '资源列表', requireAuth: true },
  },
  {
    path: '/activity/international',
    name: 'international',
    component: () => import('@/pages/activity/international'),
    meta: { title: '国际租车留资', requireAuth: true },
  },
  {
    path: '/activity/internationalFinish',
    name: 'internationalFinish',
    component: () => import('@/pages/activity/internationalFinish'),
    meta: { title: '提交完成', requireAuth: true },
  },
  {
    path: '/activity/internationalNeed',
    name: 'internationalNeed',
    component: () => import('@/pages/activity/internationalNeed'),
    meta: { title: '我的需求单', requireAuth: true },
  },
]



// WEBPACK FOOTER //
// ./src/pages/activity/activity.js